// tableReducer.ts
import {
  SET_DEFAULT_SORT_ORDER,
    SET_TABLE_DATA,
    SORT_TABLE_DATA,
  } from '../../actions/actionTypes';
  
  interface TableState {
    data: any[];
    sortKey: string | null;
    sortOrder: 'asc' | 'desc';
  }
  
  const initialState: TableState = {
    data: [],
    sortKey: null,
    sortOrder: 'asc',
  };
  
  const TableReducer = (
    state = initialState,
    action: { type: string; payload?: any }
  ): TableState => {
    switch (action.type) {
      case SET_TABLE_DATA:
        return {
          ...state,
          data: action.payload,
        };
  
      case SORT_TABLE_DATA:
        const key = action.payload;
        const order = state.sortKey === key && state.sortOrder === 'asc' ? 'desc' : 'asc';
        const sortedData = [...state.data].sort((a, b) => {
          const valA = a[key];
          const valB = b[key];
          if (typeof valA === 'string' && typeof valB === 'string') {
            return order === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
          }
          return order === 'asc' ? Number(valA) - Number(valB) : Number(valB) - Number(valA);
        });
  
        return {
          ...state,
          data: sortedData,
          sortKey: key,
          sortOrder: order,
        };
  
      case SET_DEFAULT_SORT_ORDER: {
        const { key, order } = action.payload;
        
        // Check if state.data exists and is a valid array
        if (!state.data || !Array.isArray(state.data) || state.data.length === 0) {
          return {
            ...state,
            sortKey: key,
            sortOrder: order,
          };
        }
        
        // Use Array.from instead of spread operator to avoid "(0, ge.Cc) is not a function" error
        const sortedData = Array.from(state.data).sort((a, b) => {
          const valA = a[key];
          const valB = b[key];

          if (typeof valA === 'string' && typeof valB === 'string') {
            return order === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
          }

          return order === 'asc' ? Number(valA) - Number(valB) : Number(valB) - Number(valA);
        });

        return {
          ...state,
          data: sortedData,
          sortKey: key,
          sortOrder: order,
        };
      }
  
      default:
        return state;
    }
  };
  
  export default TableReducer;
